import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showRank?: number;
}

export default function ComicCard({ comic, showRank }: ComicCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[2/3] relative overflow-hidden">
          <img
            src={comic.cover}
            alt={`韩漫 ${comic.title} - 免费在线漫画`}
            title={`${comic.title} - 好看的韩国漫画`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          {showRank && (
            <div className="absolute top-2 left-2 w-8 h-8 rounded-full bg-primary-500 text-white flex items-center justify-center font-heading text-sm font-bold">
              {showRank}
            </div>
          )}
          <div className="absolute top-2 right-2">
            <span
              className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                comic.status === 'completed'
                  ? 'bg-accent-100 text-accent-800'
                  : 'bg-primary-100 text-primary-700'
              }`}
            >
              {comic.status === 'completed' ? t('comic.completed') : t('comic.serializing')}
            </span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="font-heading text-base text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-1 text-accent-500">
              <i className="ri-star-fill text-xs"></i>
              <span className="text-xs font-medium">{comic.rating}</span>
            </div>
            <span className="text-xs text-foreground-400">
              {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} {t('comic.views')}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}